import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm, md },
} = constants.breakpoints;
const { ui } = constants.colors;

const neutral100 = ui.neutral[100];

export const containerWrapper = {
  display: "flex",
  position: "sticky",
  top: 0,
  background: "white",
  zIndex: 99,
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 16px",
  borderBottom: `1px solid ${neutral100}`,
  flexWrap: "wrap",
  gap: "16px",
  [mq.downTo(sm)]: {
    padding: "16px 40px",
  },
  [mq.downTo(md)]: {
    padding: "16px 80px",
  },
};

export const containerList = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  width: "100%",
  justifyContent: "space-between",
  [mq.downTo(xs)]: {
    width: "auto",
    gap: "16px",
  },
};

export const classesWrapper = {
  display: "flex",
  minWidth: "170px",
  maxWidth: "536px",
};
